import Phaser from 'phaser';
import { CST } from '../CST';
import buttonBehaviours from '../helpers/button-behaviours';

export default class RegisterChoose extends Phaser.Scene {
	constructor() {
		super(CST.SCENES.REGISTER_CHOOSE);
	}

	preload() {
		this.load.image('btn-personal', 'assets/btn-personal.png');
		this.load.image('btn-organisation', 'assets/btn-organisation.png');
		this.load.image('bg-creat-acc', 'assets/bg-creat-acc.png');
		this.load.image('back_btn', 'assets/english/go-backwards.png');
		this.load.image('error-generic', 'assets/english/error/error-generic.png');
		this.load.image('error-empty-field', 'assets/english/error/error-empty-field.png');
	}

	create() {
		const cx = this.cameras.main.width / 2;
		const cy = this.cameras.main.height / 2;

		this.add.image(cx, cy, 'bg-creat-acc');

		// --- Individual button ---
		this.btnIndividual = this.add
			.image(cx, cy - 50, 'btn-personal')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnIndividual, () => {
					this.scene.start(CST.SCENES.SIGNUP, { accountType: 'individual' });
				}),
			);

		this.add
			.text(cx - 200, cy + 60, 'Individual', {
				fontFamily: 'Arial',
				fontSize: '20px',
				color: '#ffffff',
				fontStyle: 'bold',
			})
			.setOrigin(0.5);

		// --- Organisation button ---
		this.btnOrganisation = this.add
			.image(cx, cy + 75, 'btn-organisation')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnOrganisation, () => {
					this.scene.start(CST.SCENES.SIGNUP_ORG);
				}),
			);

		// --- Back button ---
		this.btnBack = this.add
			.image(90, cy + 410, 'back_btn')
			.setInteractive({ useHandCursor: true })
			.on('pointerdown', () =>
				buttonBehaviours.pushOnClick(this, this.btnBack, () => {
					this.scene.start(CST.SCENES.LOGIN);
				}),
			)
			.setScale(1.5);
	}
}
